import { defaultMessageBackend, noValidation } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/placements--jira-empanada/issue-navigator-placement';

import { HighImpactOnboarding } from '../../../components/HighImpactOnboarding';

export type MessageTemplateContext = {
	message: string;
};
type RenderProps = MessageTemplateContext & PlacementRenderProps;

const hasConfiguredProjectsFromLocalStorage = (): boolean => {
	const regex = /^__storejs_jwm-view-preferences_(\d+)_list_(fieldsDetail|filter|groupBy)$/;
	return Object.keys(globalThis.localStorage).some((key) => regex.test(key));
};

export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),
		Component: ({ projectName, hasListPreference }: RenderProps) => (
			<HighImpactOnboarding
				hasListPreference={hasListPreference || hasConfiguredProjectsFromLocalStorage()}
				projectName={projectName}
			/>
		),
	},
});
